import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { api, formatBRL } from "@/lib/api";
import { ShoppingBag, DollarSign, TrendingUp, Clock, AlertCircle, Package } from "lucide-react";

const CARDS = [
  { key: "total_orders", label: "Pedidos", icon: ShoppingBag, fmt: (v) => v },
  { key: "revenue", label: "Faturamento", icon: DollarSign, fmt: formatBRL },
  { key: "avg_ticket", label: "Ticket médio", icon: TrendingUp, fmt: formatBRL },
  { key: "pending_orders", label: "Pendentes", icon: Clock, fmt: (v) => v },
  { key: "low_stock", label: "Estoque baixo", icon: AlertCircle, fmt: (v) => v },
  { key: "products_sold", label: "Peças vendidas", icon: Package, fmt: (v) => v },
];

export default function Dashboard() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)); }, []);
  return (
    <AdminLayout>
      <h1 className="text-2xl font-bold mb-6" style={{ fontFamily: "Outfit" }}>Visão geral</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {CARDS.map(({ key, label, icon: Icon, fmt }) => (
          <div key={key} data-testid={`dash-${key}`} className="bg-white border rounded-xl p-5">
            <div className="flex items-center gap-2 text-neutral-500 text-xs uppercase font-semibold"><Icon className="h-4 w-4" />{label}</div>
            <p className="text-2xl font-bold mt-2">{fmt(data[key] ?? 0)}</p>
          </div>
        ))}
      </div>
      <div className="bg-white border rounded-xl p-6 mt-6">
        <h2 className="font-bold mb-2">Modo demonstração</h2>
        <p className="text-sm text-neutral-600">O gateway Mercado Pago está em modo MOCK. Configure as credenciais nas variáveis de ambiente para ativar em produção. Alguns produtos exibem o rótulo "demo" e podem ser substituídos pelos itens reais pela aba Produtos.</p>
      </div>
    </AdminLayout>
  );
}
